import React from "react";
import PropTypes from "prop-types";

const Modal = ({ modalID, children }) => {
  return (
    <dialog id={modalID} className="modal">
      <div className="modal-box">{children}</div>
      <form method="dialog" className="modal-backdrop">
        <button>Close</button>
      </form>
    </dialog>
  );
};

export default Modal;

Modal.propTypes = {
  modalID: PropTypes.string,
  children: PropTypes.any,
};
